import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    borderRadius: 8,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    color: theme.palette.primary.main,
  },
  title: {
    fontWeight: 600,
    color: theme.palette.grey[800],
  },
  tableContainer: {
    maxHeight: 400,
    marginBottom: theme.spacing(4),
  },
  statusDisponivel: {
    backgroundColor: '#e8f5e9',
  },
  statusIndisponivel: {
    backgroundColor: '#ffebee',
  },
  statusSelecionado: {
    backgroundColor: '#e3f2fd',
  },
  resumoBox: {
    backgroundColor: theme.palette.grey[50],
    borderRadius: 8,
    padding: theme.spacing(3),
  },
  totalText: {
    fontWeight: 700,
    fontSize: '1.25rem',
  },
  servicoItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    borderRadius: 4,
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
  },
  addButton: {
    textTransform: 'none',
  },
}));
